import type { ThreadMessage } from '@/lib/services/support.service';

// ── Le fil optimiste (P07) : mon message s'affiche aussitot, « Envoi… », puis il est confirme, ou retire avec son
// texte rendu au champ ──

/** Un message du fil ; en attente, avec les adresses locales de ses captures */
export type ThreadEntry = ThreadMessage & { pending?: boolean; previews?: string[] };

let next = 0;

export function addPending(messages: ThreadEntry[], authorName: string, body: string, now = new Date().toISOString()) {
  const pendingId = `pending-${++next}`;
  const entry: ThreadEntry = { id: pendingId, author: 'USER', authorName, body, createdAt: now, readAt: null, attachments: [], pending: true };
  return { messages: [...messages, entry], pendingId };
}

/** Le message enregistre remplace l'attente, a sa place ; s'il est deja arrive par le direct, il n'est pas double */
export function confirmPending(messages: ThreadEntry[], pendingId: string, real: ThreadEntry): ThreadEntry[] {
  const without = messages.filter(m => m.id !== real.id);
  return without.map(m => (m.id === pendingId ? real : m));
}

export function failPending(messages: ThreadEntry[], pendingId: string): { messages: ThreadEntry[]; text: string } {
  const failed = messages.find(m => m.id === pendingId);
  return { messages: messages.filter(m => m.id !== pendingId), text: failed?.body ?? '' };
}
